/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish D
 * File Description: Authentication of user
 */

import React, { Component } from 'react';

import axios from 'axios';

import { CircularProgress } from '@material-ui/core';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { appUrl } from '../../../utils/config';
import ServerError from '../../defaultFiles/ServerError';

import { userLogout } from '../../../containers/actions/userActions';

import {
  viewApplicationSettings,
} from '../containers/actions/common/dashboardAction';

export default function (ComposedClass, type) {
  class PcmpAuth extends Component {
    state = {
      isLoading: true,
      serverError: false,
    };

    componentDidMount() {
      if (localStorage.network && localStorage.appName) {
        const data = {
          ...this.props.match.params,
          collabType: type,
        };
        const { params } = this.props.match;

        axios
          .post(
            `${appUrl}/${localStorage.appName}/${localStorage.network}/${type}/${params.roleName}/pcmpAuth`,
            data
          )
          .then((res) => {
            if (res.data.status === true) {
              this.setState({ isLoading: false });
            } else {
              this.props.userLogout(this.props.history);
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.props.userLogout(this.props.history);
            } else {
              this.setState({ isLoading: false });
            }
          });
      } else {
        this.props.history.push('/');
      }

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (
        nextProps.errors &&
        nextProps.errors !== this.props.errors &&
        nextProps.errors.errorCode === 500
      ) {
        this.setState({ isLoading: false, serverError: true });
      }
    }

    render() {
      if (this.state.isLoading) {
        return (
          <div style={{ textAlign: 'center', marginTop: '25%' }}>
            <CircularProgress color='primary' thickness={7} />
          </div>
        );
      }
      if (this.state.serverError) {
        return <ServerError />;
      }
      return <ComposedClass {...this.props} />;
    }
  }
  const mapStateToProps = (state) => ({ errors: state.errors });
  return connect(mapStateToProps, { userLogout,viewApplicationSettings })(withRouter(PcmpAuth));
}
